import { render, staticRenderFns } from "./CreateDocumentComunications.vue?vue&type=template&id=070100d5&scoped=true&"
import script from "./CreateDocumentComunications.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentComunications.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentComunications.vue?vue&type=style&index=0&id=070100d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070100d5",
  null
  
)

export default component.exports